import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeMap = {
    '/executive-view': { label: 'Dashboard', parent: null },
    '/drill-down-analysis': { label: 'Analytics', parent: '/executive-view' },
    '/administration-panel': { label: 'Administration', parent: null },
  };

  const currentRoute = routeMap?.[location?.pathname];

  if (!currentRoute) return null;

  const breadcrumbs = [];
  let route = currentRoute;
  let path = location?.pathname;

  while (route) {
    breadcrumbs?.unshift({ label: route?.label, path });
    if (route?.parent) {
      path = route?.parent;
      route = routeMap?.[route?.parent];
    } else {
      route = null;
    }
  }

  if (breadcrumbs?.length <= 1) return null;

  return (
    <nav
      className="flex items-center gap-2 py-3 px-6 bg-background border-b border-border"
      aria-label="Breadcrumb"
    >
      <button
        onClick={() => navigate('/executive-view')}
        className="p-1 rounded-md hover:bg-muted transition-smooth focus-ring"
        aria-label="Home"
      >
        <Icon name="Home" size={16} className="text-muted-foreground" />
      </button>
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          <Icon
            name="ChevronRight"
            size={16}
            className="text-muted-foreground"
          />
          {index === breadcrumbs?.length - 1 ? (
            <span className="text-sm font-medium text-foreground font-caption">
              {crumb?.label}
            </span>
          ) : (
            <button
              onClick={() => navigate(crumb?.path)}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-smooth font-caption focus-ring rounded px-1"
            >
              {crumb?.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;